/* KAMOK CART RECOMMENDATION QUICK-ADD V1 — scoped to existing cart suggestions, no outside apps */
(() => {
  'use strict';
  if (window.__KamokCartQuickAddV1) return;
  window.__KamokCartQuickAddV1 = true;

  const anchors = 'cart-drawer .km-cart-line-rec-card,cart-items .km-cart-line-rec-card,cart-drawer .kamok-cart-store-product,cart-items .kamok-cart-store-product';
  const route = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };
  function productJsonUrl(anchor) {
    try {
      const url = new URL(anchor.href, location.href);
      if (url.origin !== location.origin || !/\/products\/[a-z0-9-]+$/i.test(url.pathname)) return null;
      return url.pathname + '.js';
    } catch (_) { return null; }
  }
  function message(node, text) {
    node.textContent = text;
    node.setAttribute('aria-label', text);
  }
  function install(anchor) {
    if (anchor.dataset.kmQuickAddDone || !productJsonUrl(anchor)) return;
    anchor.dataset.kmQuickAddDone = '1';
    const mini = anchor.classList.contains('kamok-cart-store-product');
    const parent = anchor.parentElement;
    if (!parent) return;
    const wrap = document.createElement('div');
    wrap.className = 'km-cart-recommend-item' + (mini ? ' km-cart-recommend-mini' : '');
    parent.insertBefore(wrap, anchor);
    wrap.appendChild(anchor);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'km-cart-recommend-add';
    message(button, '＋ Į krepšelį');
    wrap.appendChild(button);
    const status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    wrap.appendChild(status);

    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      button.disabled = true;
      message(button, 'Tikrinama…');
      status.textContent = '';
      let added = false;
      try {
        const productResponse = await fetch(productJsonUrl(anchor), {
          credentials: 'same-origin', headers: { 'Accept': 'application/json' }
        });
        if (!productResponse.ok) throw Error('PRODUCT_UNAVAILABLE');
        const p = await productResponse.json();
        if (!p.available || !Array.isArray(p.variants) || p.variants.length === 0) {
          throw Error('PRODUCT_UNAVAILABLE');
        }
        if (p.variants.length !== 1) {
          message(button, 'Pasirinkti variantą');
          location.assign(anchor.href);
          return;
        }
        const variant = p.variants[0];
        if (!variant.available || !variant.id) throw Error('PRODUCT_UNAVAILABLE');

        message(button, 'Pridedama…');
        const response = await fetch(route() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
            sections: ['cart-drawer','cart-icon-bubble'],
            sections_url: location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok || result.status === 422) throw Error(result.description || result.message || 'CART_ADD_FAILED');
        added = true;
        status.textContent = 'Prekė pridėta į krepšelį';
        message(button, '✓ Pridėta');
        if (/\/cart\/?$/.test(location.pathname)) {
          location.reload();
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
          try {
            drawer.renderContents(result);
            window.dispatchEvent(new CustomEvent('kamok:cart-updated'));
          } catch (_) { location.reload(); }
        } else {
          location.reload();
        }
      } catch (error) {
        if (added) {
          location.reload();
          return;
        }
        const label = error.message === 'PRODUCT_UNAVAILABLE' ? 'Prekė šiuo metu nepasiekiama' : 'Nepavyko pridėti. Bandykite dar kartą.';
        status.textContent = label;
        message(button, 'Bandyti dar kartą');
      } finally {
        if (!added) button.disabled = false;
      }
    });
  }
  let scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll(anchors).forEach(install);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }
  function start() {
    scan();
    new MutationObserver(records => {
      if (records.some(r => r.addedNodes.length)) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('kamok:cart-updated', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();